export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/cross-circle.7a749f73.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};